/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

export const API_URL = `${process.env.API}/ratingreview`;
export const API_URL_SUFFIX = `/ratingreview`;
export const JEST_DOMAIN = `${process.env.API}`;
export const PERSIST_KEY = 'rating-review';
